export const CUSTOMERS_ACTIONS = {
    SET_CUSTOMERS: 'SET_CUSTOMERS',
    SET_CUSTOMER: 'SET_CUSTOMER',
    SHOW_FREEZE_MODAL: 'SHOW_FREEZE_MODAL',
    HIDE_FREEZE_MODAL: 'HIDE_FREEZE_MODAL',
    SHOW_UNFREEZE_MODAL: 'SHOW_UNFREEZE_MODAL',
    HIDE_UNFREEZE_MODAL: 'HIDE_UNFREEZE_MODAL',
    SHOW_DEACTIVATE_MODAL: 'SHOW_DEACTIVATE_MODAL',
    HIDE_DEACTIVATE_MODAL: 'HIDE_DEACTIVATE_MODAL',
    SHOW_EDIT_SPEND_LIMIT_MODAL: 'SHOW_EDIT_SPEND_LIMIT_MODAL',
    HIDE_EDIT_SPEND_LIMIT_MODAL: 'HIDE_EDIT_SPEND_LIMIT_MODAL',
    RELOAD_CUSTOMERS: 'RELOAD_CUSTOMERS'
};

export default function customersReducer(state, action) {
    switch (action.type) {
        case CUSTOMERS_ACTIONS.SET_CUSTOMERS:
            return { ...state, customers: action.payload };
        case CUSTOMERS_ACTIONS.SET_CUSTOMER:
            return { ...state, selectedCustomer: action.payload };
        case CUSTOMERS_ACTIONS.SHOW_FREEZE_MODAL:
            return { ...state, isFreezeModalOpen: true };
        case CUSTOMERS_ACTIONS.HIDE_FREEZE_MODAL:
            return { ...state, isFreezeModalOpen: false };
        case CUSTOMERS_ACTIONS.SHOW_UNFREEZE_MODAL:
            return { ...state, isUnfreezeModalOpen: true };
        case CUSTOMERS_ACTIONS.HIDE_UNFREEZE_MODAL:
            return { ...state, isUnfreezeModalOpen: false };
        case CUSTOMERS_ACTIONS.SHOW_DEACTIVATE_MODAL:
            return { ...state, isDeactivateModalOpen: true };
        case CUSTOMERS_ACTIONS.HIDE_DEACTIVATE_MODAL:
            return { ...state, isDeactivateModalOpen: false };
        case CUSTOMERS_ACTIONS.SHOW_EDIT_SPEND_LIMIT_MODAL:
            return { ...state, isEditSpendLimitModalOpen: true };
        case CUSTOMERS_ACTIONS.HIDE_EDIT_SPEND_LIMIT_MODAL:
            return { ...state, isEditSpendLimitModalOpen: false };
        case CUSTOMERS_ACTIONS.RELOAD_CUSTOMERS:
            return { ...state, reloadCustomers: state.reloadCustomers + 1 };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}
